import React from 'react';
import classNames from 'classnames';

import { useSetupContext } from '../context';
import { ShippingVolumeForm } from '../shipping-volume-step/shipping-volume-form';
import { FeatureInterestForm } from '../feature-interest-step/feature-interest-form';
import { CompanyAndPhoneForm } from '../company-and-phone-step/company-and-phone-form';
import { FEATURE_INTEREST, SHIPPING_VOLUME, COMPANY_PHONE } from '../constants';
import style from './style.module.less';

const SetupFormContainer = () => {
  const { currentSetupStep, shouldUseTransitionEffect } = useSetupContext();

  return (
    <div
      className={classNames(style['setup-form-container'], {
        [style['fade-in']]: shouldUseTransitionEffect,
      })}
    >
      {currentSetupStep === SHIPPING_VOLUME && <ShippingVolumeForm />}
      {currentSetupStep === COMPANY_PHONE && <CompanyAndPhoneForm />}
      {currentSetupStep === FEATURE_INTEREST && <FeatureInterestForm />}
    </div>
  );
};

export default SetupFormContainer;
